import GameAPi from '../../api/game-occurence-api'
import GameModel from '../../api/game-model'
import logger from '../../logging'

export default {
  namespaced: true,
  state: {
    connectionState: GameModel.ConnectionState.UNKNOWN,
    game: {
      code: "",
      gameClientState: GameModel.GameClientState.READY_WAITING,
      gameDetails: {},
      currentQuestion: {},
      currentCategory: {},
      revealedScore: {}
    },
    team: {
      empty: true
    },
    token: "",
    apiMessage: "",
    webSocketConnection: {}
  },
  getters: {
    token: state => {
      if (state.token === "") {
        let token = localStorage.getItem('clientToken');
        if (token) {
          state.token = token
        }
      }
      return state.token;
    },
    team: state => {
      if (state.team.empty) {
        let team = JSON.parse(localStorage.getItem('team'));
        if (team) {
          state.team = team
        }
      }
      return state.team;
    },
    getTotalPossiblePoints: state => {
      if (!state.game.revealedScore.scoredQuestions) return 0;

      let totalSum = 0;
      state.game.revealedScore.scoredQuestions.forEach(q =>
        q.segments.forEach(s => (totalSum += s.pointsValue))
      );

      return totalSum;
    }
  },
  mutations: {
    updateConnectionState(state, newState) {
      state.connectionState = newState;
    },
    updateApiMessage(state, message) {
      state.apiMessage = message;
    },
    updateGameDetails(state, game) {
      state.game.code = game.code;
      state.game.gameDetails = game.gameDetails;
    },
    updateTeamDetails(state, team) {
      state.team = team;
      localStorage.setItem('team', JSON.stringify(team));
    },
    updateClientToken(state, token) {
      state.token = token;
      localStorage.setItem('clientToken', token);
    },
    updateWebSocketConnection(state, connection) {
      state.webSocketConnection = connection;
    },
    updateGameClientState(state, gameClientState) {
      state.game.gameClientState = gameClientState;
    },
    updateCurrentQuestion(state, question) {
      state.game.currentQuestion = question;
    },
    updateCurrentCategory(state, category) {
      state.game.currentCategory = category;
    },
    updateRevealedScore(state, revealedScore) {
      state.game.revealedScore = revealedScore;
    },
    clearTeamInfo(state){
      localStorage.removeItem('clientToken');
      localStorage.removeItem('team');

      state.token = "";
      state.team = {
        empty: true
      };
    }
  },
  actions: {
    async validateGameCode({
      commit
    }, code) {
      commit('updateConnectionState', GameModel.ConnectionState.VALIDATING_CODE);
      let response = await GameAPi.validateGameCode(code);

      if (response.valid) {
        commit('updateConnectionState', GameModel.ConnectionState.VALID_CODE);
        commit('updateGameDetails', {
          code: code,
          gameDetails: response.game
        });
        commit('updateApiMessage', "");
      } else {
        commit('updateConnectionState', GameModel.ConnectionState.INVALID_CODE);
        commit('updateApiMessage', response.message);
      }
    },
    async joinGame({
      commit,
      state
    }, team) {
      commit('updateConnectionState', GameModel.ConnectionState.JOINING);
      let response = await GameAPi.joinGame(state.game.code, team);

      if (response.success) {
        commit('updateConnectionState', GameModel.ConnectionState.VALID_TEAM);
        commit('updateTeamDetails', team);
        commit('updateClientToken', response.token);
        commit('updateApiMessage', "");
      } else {
        commit('updateConnectionState', GameModel.ConnectionState.INVALID_TEAM);
        commit('updateApiMessage', response.message);
      }
    },
    async connectWebSocket({
      commit,
      state,
      dispatch
    }) {
      commit('updateConnectionState', GameModel.ConnectionState.CONNECTING);
      let connection = await GameAPi.createWebSocket(state.token, "client",
        (category) => {
          commit('updateCurrentCategory', category);
          commit('updateGameClientState', GameModel.GameClientState.INTRODUCE_CATEGORY);
        }, (question) => {
          commit('updateCurrentQuestion', question);
          commit('updateGameClientState', GameModel.GameClientState.INTRODUCE_QUESTION);
        }, () => {
          commit('updateGameClientState', GameModel.GameClientState.AWAITING_TEAM_ANSWERS);
        }, (revealedCategoryScore) => {
          commit('updateRevealedScore', revealedCategoryScore);
          commit('updateGameClientState', GameModel.GameClientState.REVEAL_CATEGORY_SCORES);
        }, (finalScore) => {
          commit('updateRevealedScore', finalScore);
          commit('updateGameClientState', GameModel.GameClientState.REVEAL_FINAL_SCORES);
        });

      commit('updateWebSocketConnection', connection);
      await dispatch('startWebSocket');

      commit('updateConnectionState', GameModel.ConnectionState.CONNECTED);
      commit('updateGameClientState', GameModel.GameClientState.READY_WAITING);

      connection.onclose(async () => {
        await dispatch('startWebSocket');
      });
    },
    async startWebSocket({
      commit,
      state,
      dispatch
    }) {
      commit('updateConnectionState', GameModel.ConnectionState.DISCONNECTED);
      try {
        await GameAPi.connectWebSocket(state.webSocketConnection);
        commit('updateConnectionState', GameModel.ConnectionState.CONNECTED);
      } catch (err) {
        logger.error(err);
        setTimeout(async () => await dispatch('startWebSocket'), 2000);
      }
    },
    async submitAnswers({
      commit,
      state
    }, currentQuestion) {

      await state.webSocketConnection.invoke("SubmitAnswers",
        currentQuestion.segments.map(s => {
          return {
            text: s.answers,
            QuestionSegmentId: s.questionSegmentId
          }
        }))
      commit('updateGameClientState', GameModel.GameClientState.READY_WAITING);
    },
    disconnectTeam({
      commit,
      state
    }){
        commit('clearTeamInfo');
        location.reload();
    }
  }
}